import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { authService } from "../services/auth";
import Captcha from "../components/Captcha";
import PasswordStrength from "../components/PasswordStrength";

export default function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    phone: "",
    companyName: "",
    plan: "FREE",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (formData.password !== formData.confirmPassword) {
      setError("As senhas não coincidem");
      return;
    }

    if (formData.password.length < 6) {
      setError("A senha deve ter pelo menos 6 caracteres");
      return;
    }

    if (!captchaVerified) {
      setError("Por favor, complete a verificação de segurança");
      return;
    }

    setLoading(true);

    try {
      await authService.register(
        formData.email,
        formData.password,
        formData.name,
        formData.phone,
        formData.companyName,
        formData.plan
      );
      navigate("/payment", { state: { plan: formData.plan } });
    } catch (err) {
      setError(err.message || "Erro ao criar conta. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: "600px", margin: "4rem auto" }}>
      <div className="panel" style={{ padding: "3rem" }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <img
            src={logo}
            alt="Sistema Único - Imobiliárias"
            style={{ width: "450px", height: "auto", marginBottom: "1.5rem" }}
          />
          <h1 style={{ marginBottom: "0.5rem" }}>Cadastre-se</h1>
          <p style={{ color: "var(--text-secondary)" }}>
            Crie sua conta no Sistema Único - Imobiliárias
          </p>
        </div>

        {error && (
          <div
            style={{
              padding: "1rem",
              background: "#fee",
              border: "1px solid #fcc",
              borderRadius: "var(--radius-md)",
              color: "#c33",
              marginBottom: "1.5rem",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="name" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Nome Completo *
            </label>
            <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="Seu nome completo"
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="email" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Email *
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="seu@email.com"
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="phone" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Telefone
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="(11) 99999-9999"
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="companyName" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Nome da Imobiliária
            </label>
            <input
              id="companyName"
              name="companyName"
              type="text"
              value={formData.companyName}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="Nome da sua imobiliária"
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="plan" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Plano
            </label>
            <select
              id="plan"
              name="plan"
              value={formData.plan}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
            >
              <option value="FREE">Gratuito</option>
              <option value="BASIC">Básico - R$ 49,90/mês</option>
              <option value="PROFESSIONAL">Profissional - R$ 119,90/mês</option>
              <option value="CONDOMINIUM">Condomínio - R$ 5/unidade/mês</option>
            </select>
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="password" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Senha *
            </label>
            <input
              id="password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="Mínimo 6 caracteres"
            />
            <PasswordStrength password={formData.password} />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="confirmPassword" style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>
              Confirmar Senha *
            </label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-md)",
                fontSize: "1rem",
              }}
              placeholder="Digite a senha novamente"
            />
          </div>

          <Captcha onVerify={setCaptchaVerified} />

          <button
            type="submit"
            className="btn-primary"
            disabled={loading || !captchaVerified}
            style={{ width: "100%", marginTop: "1.5rem", marginBottom: "1rem" }}
          >
            {loading ? "Criando conta..." : "Cadastrar"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
          <p style={{ color: "var(--text-secondary)" }}>
            Já tem uma conta?{" "}
            <Link to="/login" style={{ color: "var(--brand-blue)", fontWeight: 500 }}>
              Entrar
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
